import { SelectOption } from '@/src/components/atom/Select';
import {
  ArrayFilters,
  DefaultFilters,
  ListFilterTypeObject,
  WithOptionsFilterFilters,
} from '@/src/components/organism/Filter/types';

/**
 *  SPAM = 'spam', // 스팸 / 도배글
  OBSCENITY = 'obscenity', // 음란성 내용 및 링크
  ILLEGAL_ADVERTISING = 'illegalAdvertising', // 불법광고
  COPYRIGHT = 'copyright', // 저작권 등 권리 침해
  PRIVACY = 'privacy', // 개인정보 노출
  VIOLENCE = 'violence', // 욕설, 비방 등 폭력적인 내용
  ETC = 'etc', // 기타
 */

export const communityReportFilters: (
  communityReportReasonOptions: SelectOption[],
) => (
  | DefaultFilters
  | WithOptionsFilterFilters
  | ArrayFilters
)[] = communityReportReasonOptions => [
  {
    key: 'id',
    label: 'ID',
    placeholder: 'ID를 입력해주세요',
    type: 'TEXT',
  },
  {
    key: 'communityType',
    label: '분류',
    placeholder: '전체',
    options: [
      { label: '전체', value: '' },
      { label: '게시글', value: 'posting' },
      { label: '댓글', value: 'comment' },
    ],
    type: ListFilterTypeObject.SELECT,
  },
  {
    key: 'communityReportReasonType',
    label: '신고 사유',
    placeholder: '전체',
    options: communityReportReasonOptions,
    type: ListFilterTypeObject.SELECT,
  },
  {
    key: 'createdAt',
    label: '접수 일자',
    type: 'DATE_RANGE',
    rangeKeys: ['createdAtFrom', 'createdAtTo'],
  },
  {
    key: 'titleOrContent',
    label: '내용',
    placeholder: '내용을 입력해주세요',
  },
  {
    key: 'isHandled',
    label: '처리 상태',
    placeholder: '전체',
    options: [
      { label: '전체', value: '' },
      { label: '처리중', value: 'false' },
      { label: '처리 완료', value: 'true' },
    ],
    type: ListFilterTypeObject.SELECT,
  },
  {
    key: 'communityReportType',
    label: '게시글 상태',
    placeholder: '전체',
    options: [
      { label: '전체', value: '' },
      { label: '신고 반려', value: 'common' },
      { label: '신고 접수', value: 'reception' },
      { label: '블라인드', value: 'blind' },
    ],
    type: ListFilterTypeObject.SELECT,
  },
  {
    key: 'nick',
    label: '닉네임',
    placeholder: '닉네임을 입력해주세요',
  },
  {
    key: 'reportHandledAt',
    label: '처리 일자',
    type: 'DATE_RANGE',
    rangeKeys: ['reportHandledAtFrom', 'reportHandledAtTo'],
  },
];
